<script>
import options from './ClosedGroupOverlay.options'
export default options
</script>

<template>

  <div class="kb-member-list-overlay__content-wrapper">

    <article class="kb-stafet-donation-flow kb-create-post kb-closed-group-overlay">
        
      <section class="kb-stafet-flow-title">

        <h1 class="kb-stafet-flow-title__title">{{ getLabel("title") }}</h1>

        <div class="kb-stafet-flow-title__breaker">
          <svg role="presentation" viewBox="0 0 81 11" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M2 .5h79v1H2v-1ZM1.5 2v9h-1V2h1Zm.5-.5a.5.5 0 0 0-.5.5h-1A1.5 1.5 0 0 1 2 .5v1Z" />
          </svg>
        </div>

        <div class="kb-stafet-flow-title__description">
          <p class="kb-stafet-flow-title__description-text">{{ getLabel("description") }}</p>
        </div>

      </section>

      <section class="kb-stafet-step kb-optimizely-forms kb-stafet-donation-flow__step">

        <div class="kb-stafet-step__input-wrapper">


          <div class="kb-create-post__texteditor ValidationRequired"
            :class="isInputError && showInputErrors ? 'kb-create-post__texteditor--error' : ''">
            <label class="Form__Element__Caption">{{ getLabel("applicationTextLabel") }}</label>
            <editor api-key="no-api-key" :init="editorInit()" ref="editorRef" v-model="applicationContent">
            </editor>
            <div aria-live="assertive">
              <p v-if="isInputError && showInputErrors" role="alert" class="kb-forms Form__Element__ValidationError">{{ getLabel('applicationTextErrorMessage') }}</p>
            </div>
          </div>

        </div>
        <nav class="kb-stafet-flow-actions">
          <div class="kb-stafet-flow-actions__buttons-right-wrapper">
            <button class="kb-stafet-flow-actions__button kb-button kb-button--full-color-spot kb-button--full-color-spot"
              v-on:click="submitMemberApplication"
              data-order="last"
              @keydown.tab="tabTrap"
              :disabled="isDisabled"
              :class="{'kb-button--disabled': isDisabled}">
              {{ getLabel("requestJoinButtonText") }}
            </button>
          </div>
        </nav>


      </section>

    </article>
  </div>

</template>
